
import React, { useState } from 'react';
import './HongButtonNew.scss';

const HongButtonNew = ({
  children,
  onClick,
  className = '',
  disableTime = 0, // 기본 비활성화 시간을 0초로 설정
  ...rest
}) => {
  const [ripples, setRipples] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false); // 버튼 비활성화 상태 관리
  const [timer, setTimer] = useState(0); // 남은 비활성화 시간 관리

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rippleContainer = button.getBoundingClientRect();
    const size = Math.max(rippleContainer.width, rippleContainer.height);
    const x = event.clientX - rippleContainer.left - size / 2;
    const y = event.clientY - rippleContainer.top - size / 2;

    const newRipple = {
      key: new Date().getTime(),
      style: {
        width: size,
        height: size,
        top: y,
        left: x,
      },
    };

    setRipples((prevRipples) => [...prevRipples, newRipple]);

    setTimeout(() => {
      setRipples((prevRipples) => prevRipples.filter((ripple) => ripple.key !== newRipple.key));
    }, 600);
  };

  const handleMouseDown = (e) => {
    if (isDisabled) return; // 비활성화 상태일 때 클릭 방지
    createRipple(e);

    if (onClick) {
      onClick(e);
    }

    if (disableTime > 0) {
      setIsDisabled(true);
      setTimer(disableTime);

      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setIsDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  return (
    <button
      className={`hong-button ${className} ${isDisabled? 'disabled' : ''}`}
      // onMouseDown={handleMouseDown} 이거 하면 e.stopPropagation();  안먹혀서 수정함
      onClick={handleMouseDown}
      disabled={isDisabled} // 버튼 비활성화
      {...rest}
    >
      {ripples.map((ripple) => (
        <span key={ripple.key} className="ripple" style={ripple.style} />
      ))}
      {isDisabled && disableTime > 0 ? `다시시도 (${timer})` : children}
    </button>
  );
};

export default HongButtonNew;
